import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Layout from "../Components/Layout/Layout";
import { useDispatch } from "react-redux";
import { createNotification } from "../Redux/Actions/adminAction";
import { toast } from "react-toastify";

export default function AddNotification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    type: "",
  });

  const [isLoading, setIsLoading] = useState(false); 

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title || !formData.description || !formData.type) {
      alert("Please fill in all required fields");
      return;
    }

    try {
      setIsLoading(true);
      const notificationData = parseInt(formData.type, 10);
      let res = await dispatch(createNotification({
        title: formData.title,
        description: formData.description,
        type: notificationData,
      })
      );

      if (res?.payload?.data?.success) {
        toast.success(res?.payload?.data?.message)
        navigate("/Notification");
      } else {
        toast.error(res?.payload?.data?.message)
      }
    } catch (error) {
      console.error("Error creating notification:", error);
      toast.error("Failed to create notification. Please try again.");
    }finally {
      setIsLoading(false); 
    }
  };

  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top-inner">
          <h2>Create Notification</h2>
          <div>
            <hr />
          </div>
        </div>
      </div>
      <Container fluid>
        <div className="product-cmn-tab">
          <Row>
            <Col lg={4}>
              <div className="product-tab-left">
                <Link to="/Notification">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="40"
                    height="42"
                    viewBox="0 0 40 42"
                    fill="none"
                  >
                    <path
                      d="M10 21L8.91379 22.0345L7.92857 21L8.91379 19.9655L10 21ZM30 19.5C30.8284 19.5 31.5 20.1716 31.5 21C31.5 21.8284 30.8284 22.5 30 22.5V19.5ZM15.5805 29.0345L8.91379 22.0345L11.0862 19.9655L17.7529 26.9655L15.5805 29.0345ZM8.91379 19.9655L15.5805 12.9655L17.7529 15.0345L11.0862 22.0345L8.91379 19.9655ZM10 19.5H30V22.5L10 22.5L10 19.5Z"
                      fill="#40413A"
                    />
                  </svg>{" "}
                  Back to previous page
                </Link>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
      <Container fluid>
        <Row className="justify-content-center">
          <Col lg={8}>
            <div className="customer-form-new">
              <h2>BASIC DETAILS</h2>
              <hr className="cmn-border" />
              <div className="customer-form-inner">
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col lg={12}>
                      <div className="admin-box-select">
                        <Form.Group className="mb-3">
                          <Form.Label>Select Users</Form.Label>
                          <Form.Select
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            aria-label="Default select example"
                            required
                          >
                            <option value="">Select</option>
                            <option value="0">All</option>
                            <option value="1">Users</option>
                            <option value="2">Company</option>
                          </Form.Select>
                        </Form.Group>
                      </div>
                    </Col>
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Title</Form.Label>
                        <Form.Control
                          type="text"
                          name="title"
                          value={formData.title}
                          onChange={handleChange}
                          placeholder="Add Title..."
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12}>
                      <Form.Group className="mb-3">
                        <Form.Label>Description</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          name="description"
                          value={formData.description}
                          onChange={handleChange}
                          placeholder="Add Description..."
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col lg={12} className="d-flex justify-content-center mt-3">
                      <button type="submit" className="add-btn" disabled={isLoading}>
                       {isLoading ? "Creating..." : "Create"}
                      </button>
                    </Col>
                  </Row>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </Layout>
  );
}